import React from "react"

import { FormattedMessage } from "react-intl"
import { Modal } from "react-bootstrap"

import { withOperatorActionConfig } from "../../../config/OperatorActionConfigProvider"
import ActionForm from "../ActionForm"

const ActionEditModal = ({
  showActionEditModal,
  onHide,
  actionObj,
  reactor,
  editActionErr,
  createUpdateOrDeleteAction,
  actors,
  intl,
}) => {
  return (
    <Modal
      show={showActionEditModal}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <FormattedMessage id={"general.edit"} description={"Edit Action"} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ActionForm
          actors={actors}
          reactor={reactor}
          createUpdateOrDeleteAction={createUpdateOrDeleteAction}
          actionErr={editActionErr}
          intl={intl}
          actionObjToEdit={actionObj}
          isEditMode
        />
      </Modal.Body>
    </Modal>
  )
}

export default withOperatorActionConfig(ActionEditModal)
